// extracted by mini-css-extract-plugin
export default {"description":"NoData_description__GA8vk","no-data":"NoData_no-data__AHmad"};